import { ButtonVariant, IButtonProps, IOptionProps } from '@amobee/component-library';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { SampleVideoOptions, VideoOptions } from 'src/app/data/constants/creative-produce.const';
import { LanguageConst } from 'src/app/data/constants/language.const';
import { CreativeDTO } from 'src/app/data/dto/CreativeDTO';
import { AdProduceService } from 'src/app/services/ad-produce.service';

@Component({
  selector: 'ad-produce',
  templateUrl: './ad-produce.component.html',
  styleUrls: ['./ad-produce.component.scss']
})
export class AdProduceComponent implements OnInit {

  @Input() group: FormGroup;

  languages: Array<any> = [];
  defaultLanguage: string = LanguageConst.English.name;
  selectedLanguage: Array<string> = [];
  selectedVideoOptions: Array<any> = [];
  quantityOptions: Array<number> = _.range(1, 10);
  showMoreInformation: boolean = false;
  previewUrl: string = '';
  open: boolean = false;
  moreInfoObj: any = {};
  @ViewChild('videoControls', { static: true }) public videoControls: ElementRef;

  videoOptions: Array<any> = _.cloneDeep(VideoOptions);
  sampleVideoOptions: any = SampleVideoOptions;
  adProduceSub: Subscription;
  languageSubscription: Subscription;
  hideLanguageWarning: boolean = true;

  okButton: IButtonProps = {
    variant: ButtonVariant.PRIMARY,
    label: 'OK',
    onClick: () => {
      this.closeMoreInfo();
    }
  };
  constructor(
    private fb: FormBuilder,
    private adProduceService: AdProduceService
  ) { }

  ngOnInit() {
    this.resetProduceCreative();

    _.forEach(LanguageConst, (value: any) => {
      this.languages.push(value);
    });

    this.adProduceSub = this.adProduceService.produceCreativeObs.subscribe((val) => {
      if (val.length === 0) {
        this.resetProduceCreative();
      }
    });
    this.languageSubscription = this.languageControl.valueChanges.subscribe((languages) => {
      this.checkLanguageWarning(languages);
    });
  }

  checkLanguageWarning(campaignLauguage) {
    let hideLanguageWarning = true;
    _.forEach(this.selectedLanguage, (lan) => {
      hideLanguageWarning = hideLanguageWarning && (campaignLauguage.filter((s) => {
        return s.toUpperCase().includes(lan.toUpperCase());
      }).length > 0);
    });
    setTimeout(() => {
      this.hideLanguageWarning = hideLanguageWarning;
    });
  }

  resetProduceCreative() {
    this.selectedVideoOptions = [];
    this.selectedLanguage = [this.defaultLanguage];
    this.videoOptions = _.cloneDeep(VideoOptions);
    this.updateCreativesBaseOnVideoLengthAndQuality();
  }

  toggleLanguageSelection(isClicked, languageLabel) {
    if (isClicked) {
      this.selectedLanguage.push(languageLabel);
      this.selectedLanguage = _.uniq(this.selectedLanguage);
    } else {
      this.selectedLanguage = this.selectedLanguage.filter(language => language !== languageLabel);
    }
    this.checkLanguageWarning(this.languageControl.value);
    this.updateCreativesBaseOnVideoLengthAndQuality();
  }

  onVideoOptionChange($event, videoOption) {
    if ($event && $event.target && $event.target.checked) {
      this.selectedVideoOptions.push(videoOption);
      videoOption.checked = true;
    } else {
      this.selectedVideoOptions = this.selectedVideoOptions.filter(option => option.creative_product_id !== videoOption.creative_product_id);
    }
    this.updateCreativesBaseOnVideoLengthAndQuality();
  }

  onVideoQuantityChange(quantity: IOptionProps, videoOption) {
    this.videoOptions.forEach((option) => {
      if (option.creative_product_id === videoOption.creative_product_id) {
        option.quantity = _.parseInt(quantity.value);
      }
    });
    this.updateCreativesBaseOnVideoLengthAndQuality();
  }

  changeSampleVideoUrl(url) {
    if (!(url instanceof Event)) {
      this.videoControls.nativeElement.pause();
      this.previewUrl = url;
      this.videoControls.nativeElement.load();
    }
  }

  openFlyout(videoOption) {
    if (!this.skipCreativeValue && !this.produceCreative.disabled) {
      this.open = true;
      this.moreInfoObj = videoOption;
      this.changeSampleVideoUrl(this.sampleVideoOptions[videoOption.length].url);
    }
  }

  closeMoreInfo() {
    this.open = false;
  }

  updateCreativesBaseOnVideoLengthAndQuality() {
    while (this.produceCreative.length !== 0) {
      this.produceCreative.removeAt(0)
    }
    this.getVideoOptions().patchValue(this.selectedVideoOptions);
    this.getVideoLanguages().patchValue(this.selectedLanguage);
    for (var videoOption of this.selectedVideoOptions) {
      var i: number = 0
      while (i < videoOption.quantity) {
        i++;
        for (var language of this.selectedLanguage) {
          var creative = this.getCreative();
          var type = i + ' - ' + ((videoOption.creative_product_id === 1 || videoOption.creative_product_id === 3) ? 'Client' : 'Mediacorp')
            + " Motion Graphics Video - " + videoOption.length + " Sec - " + language;
          var name = "YOUR_NAME_HERE_" + i + " - " + ((videoOption.creative_product_id === 1 || videoOption.creative_product_id === 3) ? 'Client' : 'Mediacorp')
            + " Motion Graphics Video " + videoOption.length + " Sec - " + language;
          creative.controls['language'].patchValue(language);
          creative.controls['adDuration'].patchValue(videoOption.length);
          creative.controls['creativeAuthor'].patchValue("Seller");
          creative.controls['creative_product_id'].patchValue(videoOption.creative_product_id);
          creative.controls['name'].patchValue(name);
          creative.controls['type'].patchValue(type);
          (((creative.controls['creativeFormats'] as FormGroup).controls[0]) as FormGroup).controls['cdnUrl'].patchValue(null);
          (((creative.controls['creativeFormats'] as FormGroup).controls[0]) as FormGroup).controls['formatType'].patchValue("MXF");
          this.produceCreative.push(creative);
        }
      }
    }
  }

  getCreative(): FormGroup {
    return new CreativeDTO(this.fb).formGroup;
  }

  get produceCreative(): FormArray {
    return this.group.get('produceCreative') as FormArray;
  }

  getVideoOptions(): FormControl {
    return this.group.get('videoOptions') as FormControl;
  }

  getVideoLanguages(): FormControl {
    return this.group.get('videoLanguages') as FormControl;
  }

  get skipCreativeControl(): FormControl {
    return this.group.get("skipCreative") as FormControl;
  }

  get skipCreativeValue(): boolean {
    return this.skipCreativeControl.value;
  }

  get languageControl(): FormControl {
    return this.group.get("languages") as FormControl;
  }

  ngOnDestroy(): void {
    if (this.adProduceSub) {
      this.adProduceSub.unsubscribe();
    }
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }

}
